import { render, staticRenderFns } from "./PdfWord.vue?vue&type=template&id=6a44d2f8&scoped=true&"
import script from "./PdfWord.vue?vue&type=script&lang=js&"
export * from "./PdfWord.vue?vue&type=script&lang=js&"
import style0 from "./PdfWord.vue?vue&type=style&index=0&id=6a44d2f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a44d2f8",
  null
  
)

export default component.exports